export const PortalModule_PersonalInfoUpdates = 3;
export const PortalModule_Checklists = 12;
export const PortalModule_VistaOffice = 130;
export const PortalModule_EditExpenseReceipt = 136;
export const PortalModule_OnboardDrivingInfo = 602;
